import {
    EmbeddedCheckout,
    EmbeddedCheckoutProvider,
  } from "@stripe/react-stripe-js";
  import { loadStripe } from "@stripe/stripe-js";
  import React from "react";
  
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  
  const EmbeddedCheckoutForm = ({ clientSecret, handlePaymentComplete }) => {
    return (
      <div id="checkout">
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{
            clientSecret: clientSecret,
            onComplete: handlePaymentComplete,
          }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    );
  };
  
  export default EmbeddedCheckoutForm;